<template>
  <div class="campaign-performance">
    <div class="py-4">
      <div class="row">
        <div class="col-md-4">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">Applicant Age</h6>
            <div class="small m-auto">
              <div class="d-flex justify-content-between h5">
                <span class="text-right">20-30:</span>
                <span class="pl-3">45%</span>
              </div>
              <div class="d-flex justify-content-between h5">
                <span class="text-right">30-40:</span>
                <span class="pl-3">33%</span>
              </div>
              <div class="d-flex justify-content-between h5">
                <span class="text-right w-100">>40:</span>
                <span class="pl-3">22%</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Applicant Gender
            </h6>
            <div class="small m-auto">
              <div class="d-flex justify-content-between h5">
                <span class="text-right w-100">Male:</span>
                <span class="pl-3">71%</span>
              </div>
              <div class="d-flex justify-content-between h5">
                <span class="text-right w-100">Female:</span>
                <span class="pl-3">28%</span>
              </div>
              <div class="d-flex justify-content-between h5">
                <span class="text-right w-100">Other:</span>
                <span class="pl-3">1%</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Applicant Location
            </h6>
            <div class="small m-auto">
              <div class="d-flex justify-content-between h5">
                <div>
                <span class="text-right w-100">Europe:</span>
                <span class="pl-3">27%</span>
                </div>
                <div class="ml-4">
                <span class="text-right w-100">Asia:</span>
                <span class="pl-3">43%</span>
                </div>
              </div>
              <div class="d-flex justify-content-between h5">
                <div>
                <span class="text-right w-100">Americas:</span>
                <span class="pl-3">15%</span>
                </div>
                <div class="ml-4">
                <span class="text-right w-100">Australia/NZ:</span>
                <span class="pl-3">5%</span>
                </div>
              </div>
              <div class="d-flex m-auto justify-content-between h5">
                <span class="text-right w-100">Other:</span>
                <span class="pl-3">10%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">demographics</h6>
            <div>
              <DonutApex />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">profession breakdown</h6>
            <div>
              <BarApex />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import HeatMap from "@/components/reusable/Charts/Apex/HeatMap.vue";
import StackedBarApex from "@/components/reusable/Charts/Apex/StackedBarApex.vue";
import LineApex from "@/components/reusable/Charts/Apex/LineApex.vue";
import DonutApex from "@/components/reusable/Charts/Apex/DonutApex.vue";
import BarApex from "@/components/reusable/Charts/Apex/BarApex.vue";

export default {
  name: "Emails",
  components: {
    BasicBar,
    HeatMap,
    StackedBarApex,
    LineApex,
    DonutApex,
    BarApex,
  },
  data() {
    return {
      openAndClickRatesData: [
        {
          name: "Open Rate",
          borderColor: "#5478AF",
          backgroundColor: "#5478AF",
          values: [
            { name: "Campaign 1", value: 100 },
            { name: "Campaign 2", value: 200 },
            { name: "Campaign 3", value: 350 },
            { name: "Campaign 4", value: 500 },
            { name: "Campaign 5", value: 650 },
            { name: "Campaign 6", value: 800 },
          ],
        },
        {
          name: "Click Rate",
          borderColor: "#25436D",
          backgroundColor: "#25436D",
          values: [
            { name: "Campaign 1", value: 200 },
            { name: "Campaign 2", value: 100 },
            { name: "Campaign 3", value: 320 },
            { name: "Campaign 4", value: 450 },
            { name: "Campaign 5", value: 500 },
            { name: "Campaign 6", value: 650 },
          ],
        },
      ],
      funnelChartData: [
        {
          name: "Total Reach",
          value: 500,
        },
        {
          name: "Total Clicks",
          value: 400,
        },
        {
          name: "Total Applications Started",
          value: 350,
        },
        {
          name: "Total Applications Completed",
          value: 250,
        },
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: false,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          },
        },
      },
      campaignContributionData: [
        {
          name: "Total Reach",
          value: 500,
          backgroundColor: "#4971AB",
        },
        {
          name: "Total Clicks",
          value: 400,
          backgroundColor: "#25436D",
        },
      ],
      pieOptions: {
        maintainAspectRatio: false,
        animation: {
          duration: 0, // Disable all animations
        },
        legend: {
          display: false,
        },
      },
      defaultDatasets: [
        {
          backgroundColor: ["#25436D", "#4971AB"],
          data: [500, 400],
          label: "Total Reach",
          hoverOffset: 10,
        },
      ],
      labels: ["Total Reach", "Total Clicks"],
    };
  },
};
</script>
<style scoped>
.card {
  border: none;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.funnel {
  background: linear-gradient(to bottom, #1e3a8a, #2563eb);
  border-radius: 16px;
  color: #ffffff;
  text-align: center;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  min-height: 400px;
}

.funnel-step {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.4);
  margin: 0.5rem 0;
}
.chart-container {
  height: 200px;
}
.donut-chart {
  height: 250px;
}
</style>
